import { connect } from 'react-redux';
import { Dispatch } from 'redux';
import OrderDetailPage from 'src/components/views/Order/OrderDetailPage';
import { IStoreState, IStateCollection } from 'src/entity/StateEntity';
import { clearOrder } from 'src/redux/actions';

const mapStateToProps = ({ userState: { isAgent, userInfo }, orderState: { orderInfo } }: IStoreState) => ({
  isAgent,
  userInfo,
  orderInfo,
});

const mapDispatchToProps = (dispatch: Dispatch<IStateCollection>) => {
  return {
    clearOrder: () => dispatch(clearOrder()),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderDetailPage);



// WEBPACK FOOTER //
// ./src/containers/OrderDetail.ts